import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {
  QrTraceSaleConfirmationItem,
  QrTraceSaleConfirmationStatus
} from '../../../models/generated-models';

/** คำขอยืนยันการจำหน่ายที่ส่งมาจากระบบ QR Trace on cloud (issue #93) */
@Injectable({providedIn: 'root'})
export class QrTraceConfirmApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.serverUrl}/api/qr-trace-confirmations`;

  list(status?: QrTraceSaleConfirmationStatus): Observable<QrTraceSaleConfirmationItem[]> {
    const params = status ? new HttpParams().set('status', status) : undefined;
    return this.http.get<QrTraceSaleConfirmationItem[]>(this.baseUrl, {params});
  }

  confirm(id: number, remark?: string): Observable<QrTraceSaleConfirmationItem> {
    return this.http.post<QrTraceSaleConfirmationItem>(`${this.baseUrl}/${id}/confirm`, {remark: remark ?? null});
  }

  reject(id: number, remark?: string): Observable<QrTraceSaleConfirmationItem> {
    return this.http.post<QrTraceSaleConfirmationItem>(`${this.baseUrl}/${id}/reject`, {remark: remark ?? null});
  }
}
